/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target pH`)
};

const es_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pH objetivo`)
};

const de_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel-pH-Wert`)
};

const nl_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streef-pH`)
};

const fr_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pH cible`)
};

const it_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pH target`)
};

const pt_br2_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pH alvo`)
};

const pt_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pH alvo`)
};

const ja_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標pH`)
};

const zh_buf_ph = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标 pH`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_ph = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_ph(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_ph", locale)
	if (locale === "en") return en_buf_ph(inputs)
	if (locale === "es") return es_buf_ph(inputs)
	if (locale === "de") return de_buf_ph(inputs)
	if (locale === "nl") return nl_buf_ph(inputs)
	if (locale === "fr") return fr_buf_ph(inputs)
	if (locale === "it") return it_buf_ph(inputs)
	if (locale === "pt-BR") return pt_br2_buf_ph(inputs)
	if (locale === "pt") return pt_buf_ph(inputs)
	if (locale === "ja") return ja_buf_ph(inputs)
	return zh_buf_ph(inputs)
};